import React, { useState, useEffect } from 'react';
import APIService from './utils/APIService';
import { PEGGY_SITE_ID } from './constants/const';
import ormToast, { TOAST_TYPE } from './utils/ormToast';
import { getSessionToken } from './utils/SessionHelper';

const UserContext = React.createContext();

const UserContextProvider = props => {
  const [token, setToken] = useState(getSessionToken());
  const [userRole, setUserRole] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!token) return;
    const fetchUserInfo = async () => {
      if (token) {
        let userRes = await APIService.get(`/user/detail`);
        if (userRes.status === 200) {
          setUser(userRes.data);
          const site = userRes?.data?.sites?.find(site => site.siteid === PEGGY_SITE_ID);
          setUserRole(site.role);
        } else {
          ormToast('Fail to fetch user info. Please refresh the page', TOAST_TYPE.ERROR);
        }
      }
    };
    fetchUserInfo();
  }, [token]);

  /* 
		If user logoff or login, update token from child component
	*/
  const refreshToken = newToken => {
    setToken(newToken);
  };

  return <UserContext.Provider value={{ user, userRole, token, refreshToken }}>{props.children}</UserContext.Provider>;
};
export { UserContextProvider, UserContext };
